import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, LongTextInput, NumberInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import KeyValueInput from '../../../Common/Utils/KeyValueInput';

const ValidateRequired = required();

const styles = createStyles({
  fields: {
    width: '25%'
  },
  longFields: {
    width: '70%'
  }
});

type Props = {
  classes: any,
  expand: boolean,
  index: number,
  item: string,
  record: any
};

const MonitorCheckBody = (props: Props) => (
  <div style={{ display: props.expand ? 'initial' : 'none' }}>
    <div style={{ padding: 20 }}>
      <Field
        component={BooleanInput}
        label="Active"
        name={`${props.item}.active`}
        source={`${props.item}.active`}
        style={{ width: '0' }} />

      <div>
        <Field
          className={props.classes.fields}
          component={TextInput}
          label="Name *"
          name={`${props.item}.name`}
          source={`${props.item}.name`}
          validate={ValidateRequired} />
      </div>

      <div>
        <Field
          className={props.classes.fields}
          component={TextInput}
          label="Metric *"
          name={`${props.item}.metric`}
          source={`${props.item}.metric`}
          validate={ValidateRequired} />
      </div>

      <div style={{ display: 'inline' }}>
        <Field
          component={NumberInput}
          label="Min"
          name={`${props.item}.min`}
          source={`${props.item}.min`} />

        <span style={{ paddingLeft: 20 }}>
          <Field
            component={NumberInput}
            label="Max"
            name={`${props.item}.max`}
            source={`${props.item}.max`} />
        </span>
      </div>

      <h4>Filter</h4>
      <div style={{ display: 'inline' }}>
        <Field component={TextInput} label="Column *" name={`${props.item}.filter.column`} source={`${props.item}.column`} validate={ValidateRequired} />
        <span style={{ paddingLeft: 20 }}>
          <Field component={TextInput} label="Value *" name={`${props.item}.filter.value`} source={`${props.item}.value`} validate={ValidateRequired} />
        </span>
      </div><br />
    </div>
  </div >
);

export default withStyles(styles)(MonitorCheckBody);



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/MonitorCheckBody.tsx